import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../lib/firebase';

export function DebugFirestore() {
  const [debugInfo, setDebugInfo] = useState<string[]>([]);

  useEffect(() => {
    const runTests = async () => {
      const logs: string[] = [];
      
      try {
        // Test 1: Check auth
        const user = auth.currentUser;
        logs.push(`Auth User: ${user?.email || 'Not logged in'}`);
        logs.push(`User ID: ${user?.uid || 'No UID'}`);
        
        // Test 2: Try to read a specific document
        try {
          const docRef = doc(db, 'shortcuts', '1tMcbp5KzrJ515zAvvTV');
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            logs.push('✅ Can read specific document');
            logs.push(`Document data: ${JSON.stringify(docSnap.data(), null, 2)}`);
          } else {
            logs.push('❌ Document does not exist');
          }
        } catch (error: any) {
          logs.push(`❌ Error reading specific doc: ${error.message}`);
        }
        
        // Test 3: Try to read collection without ordering
        try {
          const querySnapshot = await getDocs(collection(db, 'shortcuts'));
          logs.push(`✅ Can read collection: ${querySnapshot.size} documents`);
          
          querySnapshot.forEach((doc) => {
            logs.push(`Doc ID: ${doc.id}, Data: ${JSON.stringify(doc.data())}`);
          });
        } catch (error: any) {
          logs.push(`❌ Error reading collection: ${error.message}`);
          logs.push(`Error code: ${error.code}`);
        }
        
      } catch (error: any) {
        logs.push(`General error: ${error.message}`);
      }
      
      setDebugInfo(logs);
    };
    
    runTests();
  }, []);

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: 20, 
      right: 20, 
      background: 'white', 
      border: '2px solid red', 
      padding: 20,
      maxWidth: 500,
      maxHeight: 400,
      overflow: 'auto',
      zIndex: 9999
    }}>
      <h3>Firestore Debug Info</h3>
      <pre style={{ fontSize: '12px' }}>
        {debugInfo.join('\n')}
      </pre>
    </div>
  );
}